/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '@dm/core';

import { SmartAssistantGifContainerModule } from '../gif-container/gif-container.module';
import { SmartAssistantObjectContainerModule } from '../object-container/object-container.module';
import { SmartAssistantSwitchModule } from '../smart-assistant-switch/smart-assistant-switch.module';
import { SmartAssistantProtectionComponent } from './object-protection.component';
import { SmartAssistantProtectionStrService } from './object-protection-str.service';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SmartAssistantGifContainerModule,
        SmartAssistantObjectContainerModule,
        SmartAssistantSwitchModule,
    ],
    declarations: [SmartAssistantProtectionComponent],
    exports: [SmartAssistantProtectionComponent],
    providers: [SmartAssistantProtectionStrService],
})
export class SmartAssistantObjectProtectionModule { }
